import { StatusEnum } from '../enums/status';

export const convertStatusEnumToString = (value: StatusEnum): string => {
  switch (value) {
    case StatusEnum.ALL:
      return 'All';
    case StatusEnum.ACTIVE:
      return 'Active';
    case StatusEnum.INACTIVE:
      return 'Inactive';
    default:
      return '';
  }
};
